import { UserApiKeyDataSerialized } from '@playq/octopus2-auth';

import { GenericTable } from '/shared/Table';

import { ApiKeysQueryFields } from './types';

export const ApiKeysTable = GenericTable.ofType<UserApiKeyDataSerialized, ApiKeysQueryFields>();
